// Header.tsx
import { NavLink } from 'react-router-dom';

type MenuItem = { path: string; label: string; protected?: boolean };

interface Props {
  loggedIn: boolean;
}

const menu: MenuItem[] = [
  { path: '/', label: 'Login' },
  { path: '/dashboard', label: 'Dashboard', protected: true },
  { path: '/upload', label: 'Upload', protected: true },
  { path: '/Stampa', label: 'Stampa', protected: true },
  { path: '/Comandi', label: 'Comandi', protected: true },
  { path: '/ListaSiti', label: 'Lista Siti', protected: true },
];

const Header: React.FC<Props> = ({ loggedIn }) => (
  <header className="app-header">
    <div className="logo"><a href="/"><img className="imglogo" alt="MaidBSK" src='../logo-maid.png'></img></a></div>

    <nav>
      <ul>
        {menu
          .filter(item => !item.protected || loggedIn)
          .map(({ path, label }) => (
            <li key={path}>
              <NavLink
                to={path}
                className={({ isActive }) => (isActive ? 'active' : undefined)}
              >
                {label}
              </NavLink>
            </li>
          ))}
      </ul>
    </nav>
  </header>
);

export default Header;